module.exports = __webpack_public_path__ + "img/wordpress.a881fdb2.webp";